import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import type {
  GroupBasedAuthorization,
  GroupForSharing,
  UserBasedAuthorization,
  UserForSharing,
} from "../../../../../../../../../api/types/svTypes.ts";
import type { ReportCompany } from "../ShareReport.types.ts";

export interface SharingGroupContextType {
  company: ReportCompany;
  currentUserId: string;
  users: UserForSharing[];
  groups: GroupForSharing[];
  availableNotAuthorizedUsers: UserForSharing[];
  companyAccess: ReportAccessType;
  setCompanyAccess: (access: ReportAccessType) => void;
  authorizedUsers: UserBasedAuthorization[];
  authorizedGroups: GroupBasedAuthorization[];
  isChanged: boolean;
  isSaving: boolean;
  onUsersSelected: (users: UserForSharing[], access: ReportAccessType) => void;
  onGroupsSelected: (groups: GroupForSharing[], access: ReportAccessType) => void;
  onUserAccessChanged: (userId: string, access: ReportAccessType) => void;
  onGroupAccessChanged: (groupId: string, access: ReportAccessType) => void;
  onRemoveUser: (userId: string) => void;
  onRemoveGroup: (groupId: string) => void;
  onSave: () => void;
}

export const SharingGroupContext = createContext<SharingGroupContextType | undefined>(undefined);

export const useSharingGroupContext = () => {
  const context = use(SharingGroupContext);
  return defined(context);
};
